(ns motorsaif.web.pages.ops.chat
  (:require
   [motorsaif.frontend-routes :as routes]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.web.components :as c]
   [motorsaif.web.components.chat :as chat]
   [motorsaif.web.online-state :as online-state]
   [re-frame.core :as rf :refer [subscribe]]
   [reagent.core :as r]
   [reagent.ratom :as ra]))

(defn chat-frame [{:keys [current-owner-id
                          from-id
                          thread-id
                          client-msgs
                          participant
                          *thread
                          touches
                          request]}]
  (let [short-id (:short/id request)]
    [:div.content.chat-frame
     ;; (do (def bzhe thread)
     ;;     nil
     ;;     )
     ;; TODO replace this with the target chatter's name
     [c/header-with-back
      (tr :page.messages.live-chat)
      (-> {:subtitle
           [:a.req-link
            {:href (routes/path-for :request {:id short-id})}
            (tr :general.request) " "
            [:span.short-id short-id]]}
          ;; If the guy got linked right into the msg, make the back button do something since no history.
          (cond-> (= (.-length js/window.history) 1)
            (assoc :back-fn #(rf/dispatch [:common/navigate! :messages]))))]
     [chat/main-chat {:request request
                      :thread-id thread-id
                      :touches touches
                      :participant participant
                      :client-msgs client-msgs
                      :from-id from-id
                      :current-owner-id current-owner-id
                      :*thread *thread}]]))

(defn root
  "Wraps chat frame passing in data from route and subscriptions"
  []
  (let [current-owner-id @(subscribe [:current-owner-id])
        {:keys [request-id owner-id]} @(subscribe [:route/parameters])

        request @(subscribe [:request request-id])

        client-msgs (subscribe [:client-msgs])

        {:keys [request thread-id from-id] :as argz}
        (let [?msg @(subscribe [:responder-thread request-id])
              thread-id [request-id current-owner-id]]
          (if ?msg ; thread exists
            (assoc ?msg
                   :thread-id thread-id
                   :from-id current-owner-id)
            ;; new response, thread does not exist
            {:from-id current-owner-id
             :thread-id thread-id
             :request request}))

        *thread (subscribe [:thread thread-id])
        ;; TODO move this atom further down so we don't dupe it
        *touched-reaction (ra/reaction
                           @(subscribe [:thread-messages thread-id])
                           (when (= @online-state/*state :online)
                             (rf/dispatch [:touch-topic thread-id {:topic-type :thread}])))]

    ;; (get-in @re-frame.db/app-db [:threads ahe])
    ;; @(subscribe [:thread-messages ahe])
    (r/create-class
      {:component-did-mount
       (fn []
         (rf/dispatch [:touch-topic thread-id {:topic-type :thread}]))
       :reagent-render
       (fn []
         @*touched-reaction
         [chat-frame {:current-owner-id current-owner-id
                      :from-id from-id
                      :thread-id thread-id
                      :client-msgs client-msgs
                      :request request
                      :*thread *thread}])})))
